import {Component, Input, OnInit} from '@angular/core';
import {AscentListEntry} from '../../model/ascent-list-entry';
import {IonicModule, ModalController} from '@ionic/angular';
import { ProfilePage } from 'src/pages/profile/profile.page';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { PipesModule } from 'src/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [IonicModule, FormsModule, CommonModule, PipesModule, TranslateModule],
  selector: 'ascent-list',
  templateUrl: './ascent-list.component.html',
  styleUrls: ['./ascent-list.component.scss'],
})
export class AscentListComponent implements OnInit {

  @Input('ascents')
  set ascents(ascents: AscentListEntry[]) {
    this._ascents = ascents;
    this.updateNumFlashed();
  }

  _ascents: AscentListEntry[];

  numFlashed = 0;

  constructor(private modalCtrl: ModalController) {
  }

  ngOnInit() {

  }

  private updateNumFlashed() {
    if (this._ascents) {
      this.numFlashed = this._ascents.filter(a => a.flash).length;
    }
  }

  async ascentClicked(ascent: any) {
    const modal = await this.modalCtrl.create({
      component: ProfilePage,
      id: 'ascent-list-page-modal',
      componentProps: {username: ascent.userName}
    });
    await modal.present();
  }
}
